import type { Grid } from '../core/paste';

/**
 * Docs, Word and Sheets put the table on the clipboard as HTML. Read the first table into
 * a grid; paragraphs inside a cell become lines. Null when there is no table.
 */
export function gridFromHtml(html: string): Grid | null {
  const doc = new DOMParser().parseFromString(html, 'text/html');
  const table = doc.querySelector('table');
  if (!table) return null;
  return [...table.querySelectorAll('tr')].map(row =>
    [...row.querySelectorAll('td, th')].map(cell => {
      const blocks = [...cell.querySelectorAll('p, li')];
      return (blocks.length ? blocks.map(b => b.textContent ?? '').join('\n') : cell.textContent ?? '').trim();
    }));
}
